export default [
    {
        field: 'password',
        type: 'password',
        vuetifyProps: {
            label: 'Contraseña',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'password_confirm',
        type: 'password',
        vuetifyProps: {
            label: 'Confirmar contraseña',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'role',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Rol',
        },
        options: {
            data: [
                {
                    name: 'Supervisor POS',
                    id: 3,
                },
                {
                    name: 'Cajero',
                    id: 4,
                },
                {
                    name: 'Vendedor',
                    id: 5,
                },
                {
                    name: 'Administrador de Ventas',
                    id: 6,
                },
                {
                    name: 'Jefe de Administración',
                    id: 7,
                },
                {
                    name: 'Administrador de Bodega',
                    id: 8,
                },
                {
                    name: 'Jefe de Bodega',
                    id: 9,
                },
                {
                    name: 'Encargado de Bodega de Temporada',
                    id: 10,
                },
                {
                    name: 'Encargado de Bodega',
                    id: 11,
                },
                {
                    name: 'Vendedor a Terreno',
                    id: 12,
                },
                {
                    name: 'Vendedor de Call Center',
                    id: 13,
                },
                {
                    name: 'Administrador de Compra',
                    id: 14,
                },
                {
                    name: 'Supervisor de compra',
                    id: 15,
                },
                {
                    name: 'Encargado de tesorería',
                    id: 16,
                },
                {
                    name: 'Encargado de cobranza',
                    id: 17,
                },
                {
                    name: 'Encargado de RRHH',
                    id: 18,
                },
                {
                    name: 'Encargado de contabilidad',
                    id: 19,
                },
                {
                    name: 'Asistente de Contabilidad',
                    id: 20,
                },

            ],
            text: 'name',
            value: 'id',
        },
        rules: [ 'required' ],
        value: '',
    },
]